import { Component, AfterViewInit, OnInit } from '@angular/core';

import { ContentService } from './services/content.service';
import {ActivatedRouteSnapshot} from '@angular/router';
import {reject} from 'q';
import 'hammerjs';



declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [ContentService]
})
export class AppComponent implements OnInit {
 /* title = 'app';
  public loading: Promise<boolean>;

  public images: any;
  public data: any;*/

  constructor(private _contentService: ContentService,
  ) {

  }

  ngOnInit() {
    /*const promise = new Promise((resolve, reject) => {
      setTimeout(() => {

        this._contentService.dataTest().subscribe(result => {
          this.images = result.card.images;
          this.data = result;
          const background = this.data.card.background_color !== '' ? this.data.card.background_color : '#fff';
          $('body').css('background-color', background );
        });
      }, 500);
    });*/
  }



}



// WEBPACK FOOTER //
// ./src/app/app.component.ts